import { MutationTree } from 'vuex';
import { EVideoRecorderMutation } from '@/video/recorder/store/video-recorder.constants';
import { IVideoRecorderState } from '@/video/recorder/store/video-recorder.types';

export const mutations: MutationTree<IVideoRecorderState> = {
  [EVideoRecorderMutation.SetStream](state: IVideoRecorderState, stream: MediaStream) {
    state.recorder.stream = stream;
  },
  [EVideoRecorderMutation.CloseStream](state: IVideoRecorderState) {
    state.recorder.stream.getTracks().forEach((track: MediaStreamTrack) => track.stop());
  },
  [EVideoRecorderMutation.SetError](state: IVideoRecorderState, error: string) {
    state.error = error;
  },
  [EVideoRecorderMutation.SetLoading](state: IVideoRecorderState, loading: boolean) {
    state.loading = loading;
  },
  [EVideoRecorderMutation.SetCreatedVideoId](state: IVideoRecorderState, videoId: string) {
    state.createdVideoId = videoId;
  },
  [EVideoRecorderMutation.ResetState](
    state: IVideoRecorderState,
    defaultState: IVideoRecorderState
  ) {
    state.createdVideoId = defaultState.createdVideoId;
    state.error = defaultState.error;
    state.loading = defaultState.loading;
    state.elapsedSeconds = defaultState.elapsedSeconds;
    state.recorder.isRecording = defaultState.recorder.isRecording;
    state.recorder.recordedBlobs = defaultState.recorder.recordedBlobs;
    state.recorder.recordedVideo = defaultState.recorder.recordedVideo;
    state.recorder.stream = defaultState.recorder.stream;
    state.recorder.superBuffer = defaultState.recorder.superBuffer;
    state.recorder.superBufferURL = defaultState.recorder.superBufferURL;
  },
  [EVideoRecorderMutation.SetRecordStatus](state: IVideoRecorderState, recording: boolean) {
    state.recorder.isRecording = recording;
  },
  [EVideoRecorderMutation.SetRecordedBlobs](state: IVideoRecorderState, blobs: Blob[]) {
    state.recorder.recordedBlobs = blobs;
  },
  [EVideoRecorderMutation.SetSuperBuffer](state: IVideoRecorderState, superBuffer?: Blob) {
    state.recorder.superBuffer = superBuffer;
  },
  [EVideoRecorderMutation.SetElapsedSeconds](state: IVideoRecorderState, seconds: number) {
    state.elapsedSeconds = seconds;
  },
  [EVideoRecorderMutation.SetSuperBufferURL](state: IVideoRecorderState, superBufferURL: string) {
    state.recorder.superBufferURL = superBufferURL;
  },
};
